import { makeStyles } from '@material-ui/styles';
import { ShopwareDeliveryTime, ShopwareUuid } from '@services/types/Shopware';
import useApplicationStore from '@services/stores/ApplicationStore';
import { DeliveryTimeAlternativeName, resolveIndicator } from '@pages/api/properties/labels';
import { useEffect, useState } from 'react';
// @ts-ignore
import Box from '@icons/send-box.svg';

const useStyles = makeStyles(() => ({
    stock: {
        color: 'inherit',
        fontSize: 'inherit',
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 2,
        fontSmoothing: 'auto',
        textWrap: 'nowrap',
        position: 'relative',
        '& svg': {
            display: 'none',
            stroke: 'none',
            strokeWidth: 0.25,
            fill: '#555555',
            width: 20,
            marginRight: 2,
        },
        '&.icon svg': {
            display: 'block',
        },
        '&.indicator': {
            '&:before': {
                content: '""',
                height: '8px',
                width: '8px',
                borderRadius: '50%',
            },
            '&.icon:before': {
                position: 'absolute',
                top: -1,
                left: 14,
            },
            '&.in-stock:before': {
                backgroundColor: 'rgb(78, 199, 145)',
            },
            '&.black:before': {
                backgroundColor: 'black',
            },
            '&.out-of-stock:before': {
                backgroundColor: 'red',
            },
            '&.incoming:before': {
                backgroundColor: 'rgb(78, 199, 145)',
            },
        }
    },
}), { name: 'StockIndicator' });

interface StockIndicatorProps {
    show?: boolean;
    deliveryTime?: ShopwareDeliveryTime | null;
    deliveryTimeId?: ShopwareUuid;
    style?: React.CSSProperties;
    className?: string | null;
    alternativeName?: DeliveryTimeAlternativeName;
    showIcon?: boolean;
}

export default function StockIndicator(
    {
        show = true,
        deliveryTime,
        deliveryTimeId = undefined,
        style = undefined,
        className = null,
        alternativeName,
        showIcon = false
    }: StockIndicatorProps,
) {
    const { getDeliveryTime } = useApplicationStore(state => state.methods);
    const classes = useStyles();
    const classNames = `${classes.stock} ${className} ${showIcon ? 'icon' : ''}`;
    const [ id, setId ] = useState<ShopwareUuid | null>(null);

    useEffect(() => {
        const id = deliveryTimeId ? deliveryTimeId : deliveryTime?.id;
        if (id) {
            setId(id);
        }
    }, [deliveryTimeId, deliveryTime?.id]);

    if (!show) {
        return null;
    }

    if (!id && deliveryTime?.unit && deliveryTime?.name) {
        let indicator = resolveIndicator(deliveryTime);

        return <span style={style} className={`${classNames} ${indicator} ${indicator ? 'indicator' : ''}`}>
            {deliveryTime.name}
        </span>;
    } else if (!id) {
        return null;
    }

    const internalDeliveryTime = getDeliveryTime(id);
    let name = internalDeliveryTime?.name;

    if (alternativeName) {
        name = internalDeliveryTime?.alternativeNames[alternativeName];
    }

    if (internalDeliveryTime) {
        let indicator = internalDeliveryTime.indicator;
        return (
            <span style={style} className={`${classNames} ${indicator} ${indicator ? 'indicator' : ''}`}>
                <Box width={25} />
                {name}
            </span>
        );
    }

    return <>
        <span style={style} className={classNames}></span>
    </>;
}
